import { render, staticRenderFns } from "./newOrder.vue?vue&type=template&id=258948c0&scoped=true&"
import script from "./newOrder.vue?vue&type=script&lang=js&"
export * from "./newOrder.vue?vue&type=script&lang=js&"
import style0 from "./newOrder.vue?vue&type=style&index=0&id=258948c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258948c0",
  null
  
)

export default component.exports